export const FETCH_GENERIC_DATA_REQUEST = 'FETCH_GENERIC_DATA_REQUEST';
export const FETCH_GENERIC_DATA_SUCCESS = 'FETCH_GENERIC_DATA_SUCCESS';
export const FETCH_GENERIC_DATA_FAILURE = 'FETCH_GENERIC_DATA_FAILURE';
export const INVALIDATE_GENERIC_DATA = 'INVALIDATE_GENERIC_DATA';
export const INVALIDATE_GENERIC_FULL_DATA = 'INVALIDATE_GENERIC_FULL_DATA';

import createReducer from '../utils/createReducer';

const initialState = {};

const reducerMap = {
  [FETCH_GENERIC_DATA_REQUEST]: (state, action) => {
    state[action.payload.id] = {
      ...(state[action.payload.id] || {}),
      loading: true,
      error: null,
      isError: false
    };
  },
  [FETCH_GENERIC_DATA_SUCCESS]: (state, action) => {
    state[action.payload.id] = {
      loading: false,
      data: action.payload.data,
      error: null,
      isError: false,
      lastUpdated: Date.now()
    };
  },
  [FETCH_GENERIC_DATA_FAILURE]: (state, action) => {
    state[action.payload.id] = {
      ...(state[action.payload.id] || {}),
      loading: false,
      error: action.payload.error,
      isError: action.payload.isError ?? true
    };
  },
  [INVALIDATE_GENERIC_FULL_DATA]: () => {
    return {};
  },
  [INVALIDATE_GENERIC_DATA]: (state, action) => {
    delete state[action.payload.id];
  }
};

export default createReducer(initialState, reducerMap);
